import { render, staticRenderFns } from "./SaveNotice.vue?vue&type=template&id=03960d71&scoped=true&"
import script from "./SaveNotice.vue?vue&type=script&lang=js&"
export * from "./SaveNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03960d71",
  null
  
)

export default component.exports